// extracted by mini-css-extract-plugin
export default {"path":"Share_path__dLDoH","heading":"Share_heading__+LVXL","label":"Share_label__m2ier","copy_container":"Share_copy_container__116av"};